import React, { useEffect, useMemo, useRef, useState } from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import Typography from '@material-ui/core/Typography';

import ModalFull from 'components/Tvendo/Common/ModalFull';
import { WithApp } from 'contexts/appContext';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import FilterArticle from 'hooks/FilterArticle';
import { Checkbox, Divider, TextField } from '@material-ui/core';
import { onlyInteger } from 'hooks/Pipe';

const imgUrl = process.env.REACT_APP_IMG_PRODUCTS;

const useStyles = makeStyles({
  root: {
    width: '100%',
    marginBottom: '15px',
    '& img': {
      width: '100%',
      height: '100px',
      objectFit: 'contain',
      paddingTop: '10px',
      paddingLeft: '10px',
    },
  },
  contDivCard: {
    display: 'flex',
    cursor: 'pointer',
    height: '115px',
    '&:hover': {
      backgroundColor: '#8e24aa12',
    },
  },
  cardActions: {
    padding: 0,
    alignItems: 'flex-end',
    maxWidth: '400px',
  },
  productSelects: {
    overflowY: 'auto',
    maxHeight: '78Vh',
    border: '3px solid #e2e2e5',
    borderRadius: '5px',
    padding: '6px',
    '&::-webkit-scrollbar-track': {
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar': {
      width: '7px',
      backgroundColor: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#d5d5d9',
      borderRadius: '10px',
    },
    '&::-webkit-scrollbar:horizontal': {
      display: 'none',
    },
  },
});

function CardContainer(props) {
  const { product, observer } = props;
  const imgRef = useRef();

  useEffect(() => {
    if (observer === null) {
      return;
    }
    observer.observe(imgRef.current);
  }, [observer]);

  return (
    <>
      <div style={{ width: '85px' }}>
        <CardMedia
          ref={imgRef}
          component="img"
          className="lazy-loaded-image lazy"
          alt={product.ItemName}
          image="https://promotonews.com/wp-content/uploads/2020/09/IMG-LOGO.jpg"
          data-src={imgUrl + product.ItemCode + '.jpg'}
          title={product.ItemName}
          onError={(e) => {
            e.target.src = 'https://promotonews.com/wp-content/uploads/2020/09/IMG-LOGO.jpg';
          }}
        />
      </div>
      <CardContent style={{ width: '100%' }}>
        <Typography gutterBottom variant="h6" style={{ fontSize: '14px', margin: '0' }}>
          {product.ItemName}
        </Typography>
        <div style={{ height: '100%' }}>
          <span style={{ fontSize: '12px', fontWeight: '500' }}>{product.ItemCode}</span>
          <span style={{ fontSize: '12px', fontWeight: '500', marginLeft: '15px' }}>
            Cant. x Paq. {product.NumInSale}
          </span>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span
              style={{
                fontSize: '13px',
                fontWeight: '500',
                color: product.Aviable > 0 ? 'black' : '#f50057',
              }}
            >
              STOCK: {product.Aviable}
            </span>
            <span style={{ fontSize: '15px', fontWeight: '500', color: '#f50057' }}>
              S/ {parseFloat(product.unit_price).toFixed(2)}
            </span>
          </div>
        </div>
      </CardContent>
    </>
  );
}

export default WithApp(function ModalFilterProduct(props) {
  const classes = useStyles();
  const {
    saleType,
    open,
    setOpen,
    dataSale,
    productSelects,
    handleChangeRow,
    addProductCheck,
    calcImport,
    deleteRow,
    deliveryType,
  } = props;

  const handleClose = () => {
    setOpen(false);
    setArticleFiltereds([]);
  };

  const [articleFiltereds, setArticleFiltereds] = useState([]);
  const [textInput, setTextInput] = useState({ ItemCode: '', ItemName: '' });
  const [stock, setStock] = useState(true);
  const [lazyImageObserver, setLazyImageObserver] = useState(null);

  function setDataArticle(data) {
    let newArr = data.map((item) => {
      return { ...item, digitate_packages: 0, digitate_units: 0 };
    });
    setArticleFiltereds(newArr);
  }

  useEffect(() => {
    const lazyImageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let lazyImage = entry.target;
          lazyImage.src = lazyImage.dataset.src;
          lazyImage.classList.remove('lazy');
          lazyImageObserver.unobserve(lazyImage);
        }
      });
    });
    setLazyImageObserver(lazyImageObserver);
  }, [articleFiltereds, productSelects, saleType]);

  const [entity, paramFilter] = useMemo(() => {
    if (saleType === 'O' || deliveryType === 'O') {
      return [`base/zone/${dataSale.base_zone_id}/products`, null];
    }

    return [
      'base/seller/products',
      {
        base_customer_route_id: dataSale.base_customer_route_id,
        base_seller_id: dataSale.base_seller_id,
      },
    ];
  }, [saleType, deliveryType, dataSale]);

  return (
    <ModalFull title="Filtro de Productos" open={open} setOpen={handleClose}>
      <GridContainer>
        <GridItem xs={12} lg={12}>
          <FilterArticle
            getArticleFiltereds={setDataArticle}
            entity={entity}
            paramFilter={paramFilter}
          >
            {articleFiltereds.length > 0 ? (
              <>
                <GridItem xs={12} md={2}>
                  <TextField
                    label="Código producto"
                    margin="normal"
                    fullWidth
                    onChange={(e) => {
                      setTextInput({ ...textInput, ItemCode: e.target.value });
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={2}>
                  <TextField
                    label="Nombre producto"
                    margin="normal"
                    fullWidth
                    onChange={(e) => {
                      setTextInput({ ...textInput, ItemName: e.target.value });
                    }}
                  />
                </GridItem>
              </>
            ) : undefined}
            <GridItem xs={12} md={2} style={{ display: 'flex', alignItems: 'center' }}>
              <Checkbox checked={!stock} onChange={() => setStock(!stock)} /> Mostrar Todos
            </GridItem>
          </FilterArticle>

          <Divider style={{ marginTop: '15px', marginBottom: '15px' }} />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} lg={9}>
          <div className={classes.productSelects}>
            <p style={{ textTransform: 'none' }}>
              {articleFiltereds.length === 0
                ? 'Seleccione los filtros para mostrar productos...'
                : undefined}
            </p>
            <GridContainer>
              {articleFiltereds
                .filter(
                  ({ id: id1, ItemCode: ItemCode1, ItemName: ItemName1, Aviable: Aviable }) =>
                    !productSelects.some(({ id: id2 }) => id2 == id1) &&
                    ItemCode1?.toLowerCase().includes(textInput.ItemCode?.toLowerCase()) &&
                    ItemName1?.toLowerCase().includes(textInput.ItemName?.toLowerCase()) &&
                    (stock ? Aviable > 0 : true),
                )
                .map((item, i) => {
                  return (
                    <GridItem xs={12} sm={6} md={4} lg={4} key={i}>
                      <Card className={classes.root} style={{ height: '115px' }}>
                        <div
                          className={classes.contDivCard}
                          onClick={() => addProductCheck(item, calcImport(item))}
                        >
                          <CardContainer product={item} observer={lazyImageObserver} />
                        </div>
                      </Card>
                    </GridItem>
                  );
                })}
            </GridContainer>
          </div>
        </GridItem>
        <GridItem xs={12} lg={3}>
          <div className={classes.productSelects}>
            <h5>
              <b>Productos Seleccionados</b>
            </h5>
            <h6 style={{ textTransform: 'none' }}>
              {productSelects.length === 0 ? 'No hay productos que mostrar...' : undefined}
            </h6>
            {productSelects.map((item, i) => {
              return (
                <Card className={classes.root} style={{ height: '165px' }} key={i + productSelects}>
                  <div
                    className={classes.contDivCard}
                    onClick={(e) => {
                      e.currentTarget.parentElement.querySelector('#check' + item.id).click();
                    }}
                  >
                    <CardContainer product={item} observer={lazyImageObserver} />
                  </div>
                  <CardActions className={classes.cardActions}>
                    <Checkbox
                      id={'check' + item.id.toString()}
                      checked={productSelects.some((obj) => obj.id == item.id)}
                      onChange={() => deleteRow(item.id)}
                    />
                    <TextField
                      label="Paquete"
                      name="digitate_packages"
                      margin="none"
                      size="small"
                      value={item.digitate_packages || ''}
                      fullWidth
                      onChange={(e) => {
                        handleChangeRow(e, item.id);
                      }}
                      onKeyPress={onlyInteger}
                    />
                    <TextField
                      label="Unidad"
                      name="digitate_units"
                      margin="none"
                      size="small"
                      value={item.digitate_units || ''}
                      fullWidth
                      onChange={(e) => {
                        handleChangeRow(e, item.id);
                      }}
                      onKeyPress={onlyInteger}
                    />
                  </CardActions>
                </Card>
              );
            })}
          </div>
        </GridItem>
      </GridContainer>
    </ModalFull>
  );
});
